
import './history.scss';
import { Titles } from '../shared/components/titles/titles';
import { Badge, Box, Grid } from '@mui/material';
import { DATE_PICKER } from './constants/datepicker';
import { TITLE_HISTORY } from './constants/title';
import { useEffect, useState } from 'react';
import { CLASSES_TAKEN } from '../shared/graphql/branch';
import format from 'date-fns/format';
import { useQuery } from '@apollo/client';
import { SkeletonTable } from '../shared/components/skeleton-table/skeleton-table';
// import { TableHistoryClass } from './components/table-history-class/table-history-class';
import DetailClass from '../detail-class/detail-class';
import { useLocation } from 'react-router-dom';
import { sendPageView } from '../shared/services/analytics';
import Icon from '../shared/components/icon/icon';
import { SelectMui } from '../shared/components/select/select';
import { DataNotFound } from '../shared/components/data-not-found/data-not-found';
import { DATA_NOT_FOUND } from './components/table-history-class/constants/DataNotFound';

let filters: {
    branchId: number,
    date: string,
    classIds: number[],
    day: number,
    hour: string,
};

function DataTableHistory({ date, branchId, classes, day, hour, takeAttendance }: { date: Date, branchId: number, classes?: number[], day?: number, hour?: string, takeAttendance: (detailClass: any) => void }) {

    const location = useLocation();
    useEffect(() => {
        sendPageView(location.pathname + location.search, "Historia de clase");
    }, [location]);

    filters = {
        branchId: branchId,
        date: format(date, 'yyyy-MM'),
        classIds: classes!,
        day: day!,
        hour: hour!,
    };

    const { loading, error, data } = useQuery(CLASSES_TAKEN, { variables: filters });

    if (error) console.log(`Submission error! ${error.message}`);

    if (loading) return <SkeletonTable></SkeletonTable>;

    return (
        <div>
            {/* <TableHistoryClass tableData={data.classByMonthProvider.data} takeAttendance={(dataCalendar) => takeAttendance(dataCalendar)}></TableHistoryClass> */}
            {data.classByMonthProvider.data.map((el: any) => (
                <Grid xs={12} className='card card-history'>
                    <Grid container>
                        <Grid item xs={6} className='text-info'>
                            <Box sx={{ display: 'inline-flex' }}>
                                <h3>{el.calendar.classFit.name}</h3>   </Box>
                            <Box sx={{ display: 'inline-flex' }}>
                                <p className='ml-1'>
                                    <span>{format(new Date(el.calendar.start), "dd/MM/yyyy")} </span>
                                    |
                                    <span> {format(new Date(el.calendar.start), "HH:mm")}</span>
                                </p>
                            </Box>
                        </Grid>
                        <Grid item xs={6} className='reservation-info' sx={{ textAlign: 'right' }}>
                            <Box sx={{ display: 'inline-flex' }}>
                                <Icon name='user-check' width='25' height='25' color='#06BAA6' />
                                <span className='ml-05'>
                                    {el.total} {el.total === 1 ? ' inscrito' : ' inscritos'}
                                </span>
                            </Box>
                            <Box sx={{ display: 'inline-flex' }} className='ml-1'>
                                <Icon name='paid' width='25' height='25' color='#06BAA6' />
                                <span className='ml-05'>${el.totalValue ?? '0'}</span>
                            </Box>
                        </Grid>

                    </Grid>
                    <Box display={'-webkit-inline-box'} className='statistics-history'>
                        <Badge component="span" className='badge-history badge-green'>
                            <span className='mr-05'>{el.taked}</span>
                            asistencias
                        </Badge>
                        <Badge component="span" className='badge-history badge-red'>
                            <span className='mr-05'>{el.noShow}</span>
                            inasistencias
                        </Badge>
                        <Badge component="span" className='badge-history badge-gray'>
                            <span className='mr-05'>{el.canceled}</span>
                            cancelación
                        </Badge>
                        <Badge component="span" className='badge-history badge-yellow'>
                            <span className='mr-05'>{el.lateCancel}</span>
                            cancelación tarde
                        </Badge>
                    </Box>
                </Grid>
            ))}

            {!data.classByMonthProvider.data.length && (
                <DataNotFound data={DATA_NOT_FOUND} />
            )}
        </div>
    );
}


export default function History({ branch }: { branch: number }) {
    const [openDetailClass, setOpenDetailClass] = useState<boolean>(false);
    const [detailClass, setDetailClass] = useState<any>();
    const [date, setDate] = useState(new Date());
    DATE_PICKER.valueDate = date;

    const changeOpenDetailClass = (dataClass?: any) => {
        if (dataClass) setDetailClass(dataClass);
        setOpenDetailClass(!openDetailClass);
    }

    const minDate = new Date(DATE_PICKER.minDate);
    const maxDate = new Date(DATE_PICKER.maxDate);
    const minYear = minDate.getFullYear();
    const maxYear = maxDate.getFullYear();

    const allowedYears = Array.from({ length: maxYear - minYear + 1 }, (_, index) => {
        const year = minYear + index;
        return { 'id': year, 'name': year };
    });

    let currentMont = new Date().toLocaleString('default', { month: 'long' });
    const [selectedYear, setSelectedYear] = useState<any>(maxYear);
    const [selectedMonth, setSelectedMonth] = useState<string>(currentMont);

    function getMonthNumberByName(month: string) {
        switch (month) {
            case 'enero': return 1;
            case 'febrero': return 2;
            case 'marzo': return 3;
            case 'abril': return 4;
            case 'mayo': return 5;
            case 'junio': return 6;
            case 'julio': return 7;
            case 'agosto': return 8;
            case 'septiembre': return 9;
            case 'octubre': return 10;
            case 'noviembre': return 11;
            case 'diciembre': return 12;
            default: return 1;
        }

    }

    function getMonthsBetweenDates(minDate: Date, maxDate: Date, selectedYear: number) {
        const months = [];
        let currentDate = new Date(minDate);

        while (currentDate <= maxDate) {
            if (currentDate.getFullYear() === selectedYear) {
                const month = currentDate.toLocaleString('default', { month: 'long' });
                months.push({ 'id': month, 'name': month });
            }

            currentDate.setMonth(currentDate.getMonth() + 1);
        }

        return months;
    }

    const handleYearChange = (year: number) => {
        setSelectedYear(year);

        const newMinDate = new Date(`${year}-01-01`);
        const newMaxDate = new Date(`${year}-12-31`);

        if (new Date().getFullYear() === year) {
            const availableMonths = getMonthsBetweenDates(newMinDate, newMaxDate, year);
            setSelectedMonth(availableMonths.length > 0 ? availableMonths[0].id : '');
        }
    }

    useEffect(() => {
        const dateFilter = `${getMonthNumberByName(selectedMonth)}-${new Date().getDate()}-${selectedYear}`;

        setDate(new Date(dateFilter));
    }, [selectedMonth, selectedYear]);


    if (openDetailClass && detailClass) return <DetailClass attendance={() => changeOpenDetailClass()} dataCalendar={detailClass}></DetailClass>;

    return (
        <Box className="section-menu">
            <Grid container>
                <Grid item xs={12}>
                    <Titles props={TITLE_HISTORY} />
                </Grid>
                <Grid item xs={12}>
                    {/* <DatePickerMonthYear dateData={DATE_PICKER} onAction={(newDate: any) => setDate(newDate)}></DatePickerMonthYear> */}

                    <Box sx={{ display: 'flex' }}>
                        <SelectMui
                            selectData={{
                                value: selectedMonth,
                                items: getMonthsBetweenDates(new Date(DATE_PICKER.minDate), new Date(DATE_PICKER.maxDate), selectedYear),
                                size: 'large',
                                textLabel: 'Continuar',
                                id: 'month',
                                label: false,
                            }}
                            onAction={(newValueMonth: any) => setSelectedMonth(newValueMonth)}
                        ></SelectMui>

                        <SelectMui
                            selectData={{
                                // value: String(maxYear),
                                value: selectedYear,
                                items: allowedYears,
                                size: 'large',
                                textLabel: 'Continuar',
                                id: 'year',
                                label: false,
                            }}
                            onAction={(newValueYear: any) => handleYearChange(Number(newValueYear))}
                        ></SelectMui>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <DataTableHistory date={date} branchId={branch} takeAttendance={(detailClass) => changeOpenDetailClass(detailClass)}></DataTableHistory>
                </Grid>
            </Grid>
        </Box>
    );
}